import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CurrencyInput from '../CurrencyInput';
import { API_BASE_URL } from '../../../config/ApiConfig';
import { formatCurrency } from '../../utils/formatMoeda';

function SreaAjusteModal({ show, onClose, onSubmit, form, handleChange, items, setForm }) {
  const isEditing = form && form._isEditing;
  const [programas, setProgramas] = useState([]);
  const token = localStorage.getItem('token');
  // total calculado diretamente a partir dos campos do formulário
  const totalVlr = (parseFloat(form.vlrC || 0) || 0) + (parseFloat(form.vlrK || 0) || 0);

  useEffect(() => {
    if (!show) return;
    axios.get(`${API_BASE_URL.PROGRAMA}/all`, { headers: { Authorization: token ? `Bearer ${token}` : undefined } })
      .then(r => setProgramas(Array.isArray(r.data) ? r.data : []))
      .catch(() => setProgramas([]));
  }, [show, token]);

  // ao selecionar um programa, carregar o ajuste existente (se houver)
  useEffect(() => {
    if (!show || !form || !form.idPrograma) return;
    // se o pai já tiver carregado os ajustes, usa-os localmente
    if (Array.isArray(items) && items.length > 0) {
      const prog = programas.find(p => String(p.id) === String(form.idPrograma));
      const found = items.find(it => String(it.idPrograma) === String(form.idPrograma) || (prog && String(it.idPrograma) === String(prog.descricao)));
      if (found) {
        // usar setForm para atualizar o estado do pai de forma imediata
        if (typeof setForm === 'function') {
          setForm(f => ({ ...f, idPrograma: form.idPrograma, vlrC: found.vlrC, vlrK: found.vlrK, _isEditing: true }));
        } else {
          handleChange({ target: { name: 'vlrC', value: found.vlrC } });
          handleChange({ target: { name: 'vlrK', value: found.vlrK } });
          handleChange({ target: { name: '_isEditing', value: true } });
        }
      } else {
        if (typeof setForm === 'function') {
          setForm(f => ({ ...f, vlrC: '', vlrK: '', _isEditing: false }));
        } else {
          handleChange({ target: { name: 'vlrC', value: '' } });
          handleChange({ target: { name: 'vlrK', value: '' } });
          handleChange({ target: { name: '_isEditing', value: false } });
        }
      }
      return;
    }
    const cnpj = localStorage.getItem('cnpj');
    const ano = localStorage.getItem('ano');
    axios.get(`${API_BASE_URL.SREA_AJUSTE}/search`, { params: { idEscola: cnpj, ano }, headers: { Authorization: token ? `Bearer ${token}` : undefined } })
      .then(r => {
        const data = Array.isArray(r.data) ? r.data : [];
        const found = data.find(it => String(it.idPrograma) === String(form.idPrograma));
        if (found) {
          handleChange({ target: { name: 'vlrC', value: found.vlrC } });
          handleChange({ target: { name: 'vlrK', value: found.vlrK } });
          handleChange({ target: { name: '_isEditing', value: true } });
        } else {
          handleChange({ target: { name: 'vlrC', value: '' } });
          handleChange({ target: { name: 'vlrK', value: '' } });
          handleChange({ target: { name: '_isEditing', value: false } });
        }
      })
      .catch(() => {
        handleChange({ target: { name: 'vlrC', value: '' } });
        handleChange({ target: { name: 'vlrK', value: '' } });
        handleChange({ target: { name: '_isEditing', value: false } });
      });
  }, [show, form && form.idPrograma, items]);

  // função utilitária para carregamento imediato ao mudar o select
  function loadAjusteForProgram(programId) {
    if (!programId) return;
    // loadAjusteForProgram invoked
    // primeiro tenta usar dados já carregados pelo pai
    if (Array.isArray(items) && items.length > 0) {
      const prog = programas.find(p => String(p.id) === String(programId));
      const found = items.find(it => String(it.idPrograma) === String(programId) || (prog && String(it.idPrograma) === String(prog.descricao)));
      if (found) {
        if (typeof setForm === 'function') {
          setForm(f => ({ ...f, idPrograma: programId, vlrC: found.vlrC, vlrK: found.vlrK, _isEditing: true }));
        } else {
          handleChange({ target: { name: 'vlrC', value: found.vlrC } });
          handleChange({ target: { name: 'vlrK', value: found.vlrK } });
          handleChange({ target: { name: '_isEditing', value: true } });
        }
        return;
      }
      handleChange({ target: { name: 'vlrC', value: '' } });
      handleChange({ target: { name: 'vlrK', value: '' } });
      handleChange({ target: { name: '_isEditing', value: false } });
      return;
    }
    const cnpj = localStorage.getItem('cnpj');
    const ano = localStorage.getItem('ano');
    axios.get(`${API_BASE_URL.SREA_AJUSTE}/search`, { params: { idEscola: cnpj, ano }, headers: { Authorization: token ? `Bearer ${token}` : undefined } })
      .then(r => {
        const data = Array.isArray(r.data) ? r.data : [];
        const found = data.find(it => String(it.idPrograma) === String(programId));
        if (found) {
          handleChange({ target: { name: 'vlrC', value: found.vlrC } });
          handleChange({ target: { name: 'vlrK', value: found.vlrK } });
          handleChange({ target: { name: '_isEditing', value: true } });
        } else {
          handleChange({ target: { name: 'vlrC', value: '' } });
          handleChange({ target: { name: 'vlrK', value: '' } });
          handleChange({ target: { name: '_isEditing', value: false } });
        }
      })
      .catch(() => {
        handleChange({ target: { name: 'vlrC', value: '' } });
        handleChange({ target: { name: 'vlrK', value: '' } });
        handleChange({ target: { name: '_isEditing', value: false } });
      });
  }

  // não busca/filtra totais no modal: total calculado localmente a partir dos campos do formulário

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className={`modal-header ${isEditing ? 'bg-primary' : 'bg-success'} text-white`} style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-pencil me-2"></i>{isEditing ? 'EDITAR AJUSTE SREA' : 'NOVO AJUSTE SREA'}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label className="form-label">Programa *</label>
                <select className="form-select" name="idPrograma" value={form.idPrograma} onChange={e => { handleChange(e); loadAjusteForProgram(e.target.value); }} required disabled={isEditing}>
                  <option value="">Selecione...</option>
                  {programas.map(p => <option key={p.id} value={p.id}>{p.descricao}</option>)}
                </select>
              </div>
              <div className="row mb-3">
                <div className="col-md-4">
                  <label className="form-label">Custeio</label>
                  <CurrencyInput className="form-control" name="vlrC" value={form.vlrC} onChange={handleChange} />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Capital</label>
                  <CurrencyInput className="form-control" name="vlrK" value={form.vlrK} onChange={handleChange} />
                </div>
                <div className="col-md-4">
                  <label className="form-label small">Total</label>
                  <div className="form-control bg-light fw-bold">{formatCurrency(totalVlr)}</div>
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
              
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SreaAjusteModal;
